// extracted by css-extract-rspack-plugin
export default {"root":"root-EJ98np drop-shadow-sm","lift":"lift-TkFbgo","borderless":"borderless-OoefV5","topPlacement":"topPlacement-yuO4nB drop-shadow-top-sm"};